import { AdProductDisplay, AdProductVideo } from '@features/campaigns/shared/types/campaign';

export function isAdProductDisplayNonNull(data: AdProductDisplay | null): data is AdProductDisplay {
  return data !== null;
}

export function isAdProductVideoNonNull(data: AdProductVideo | null): data is AdProductVideo {
  return data !== null;
}
